<template>
  <div>
    <lf-checkbox
      v-for="(attribute, index) in attributes"
      :key="attribute.id"
      class="flex items-center space-x-3 rounded-sm p-1 break-all hover:bg-gray-100"
      :class="{
        'bg-blue-100': previewIndex === index,
        hidden: !attributeIsVisible(attribute.id),
      }"
      label-class="w-full"
      :value="attribute.id"
      :name="attribute.id"
      :model-value="selectedIds"
      @update:model-value="update"
    >
      <div class="flex flex-1 items-center justify-between">
        <highlight-text :content="attribute.name" :needle="searchPhrase" />
        <span>
          <icon-base
            v-tooltip="
              previewIndex === index
                ? $t('COMMON.CLICK_TO_PREVIEW_EXIT')
                : $t('COMMON.CLICK_TO_PREVIEW')
            "
            class="place-self-center"
            :class="{ 'text-primary': previewIndex === index }"
            height="20"
            width="20"
            view-box="0 0 16 16"
            :icon="IconPreview"
            @click.prevent="togglePreview(index)"
          />
        </span>
      </div>
    </lf-checkbox>

    <custom-attributes-preview-wrapper
      :attributes-to-preview="attributes"
      :active-index="previewIndex"
      class="rounded-sm bg-white py-3 shadow-lg"
      @update:active="togglePreview"
    />
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";

import HighlightText from "@/components/HighlightText.vue";
import IconPreview from "@/components/icons/IconPreview.vue";
import IconBase from "@/components/ui/IconBase.vue";
import LfCheckbox from "@/components/ui/inputs/LfCheckbox.vue";
import CustomAttributesPreviewWrapper from "@/views/profile/components/dataOrchestration/configPanel/customAttributes/CustomAttributesPreviewWrapper.vue";

import type { IAttribute, IStepAttribute } from "@/models/orchestration";

const emit = defineEmits<{
  "update:selected": [IAttribute[]];
}>();

const props = defineProps<{
  attributes: IAttribute[];
  filteredAttributes: IAttribute[];
  selected: IStepAttribute[];
  searchPhrase?: string;
}>();

const previewIndex = ref(-1);

const selectedIds = computed(() => props.selected.map((attr) => attr.id));

const togglePreview = (index: number) => {
  previewIndex.value = index === previewIndex.value ? -1 : index;
};

const attributeIsVisible = (attributeId: string) =>
  props.filteredAttributes.some((attribute) => attribute.id === attributeId);

const update = (updatedIds: IStepAttribute["id"][]) => {
  const updatedAttributes = props.attributes.filter(({ id }) =>
    updatedIds.includes(id)
  );
  emit("update:selected", updatedAttributes);
};
</script>
